import { gql } from '@apollo/client';

export default gql`
  mutation($email: String!, $password: String!) {
    loginIssuerAdmin(email: $email, password: $password) {
      authToken
    }
  }
`;
